import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ElofizetoCegService } from '../../services/elofizeto-ceg.service';

export const cegSelectionGuard: CanActivateFn = (route, state) => {
    const elofizetoCegService = inject(ElofizetoCegService);
    const router = inject(Router);

    if (elofizetoCegService.hasSelectedCeg()) {
        return true;
    }

    return router.createUrlTree(['/select-ceg'], {
        queryParams: { returnUrl: state.url }
    });
};
